import { createSlice } from '@reduxjs/toolkit';

import {
    FETCH_SYSTEM_TYPES,
    FETCH_SYSTEM_TYPES_FAILURE,
    FETCH_SYSTEM_TYPES_SUCCESS,
    INITIALIZE_FORM,
    RESET,
    RESET_FORM,
    SAVE,
    SAVE_FAILURE,
    SAVE_SUCCESS,
    SET_IS_NEW_RECORD,
    SET_IS_OPEN_MODAL,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    initialValues: {
        id: null,
        language: '',
        title: '',
        system: '',
        type: '',
    },
    save: {
        data: {},
        errors: [],
        isSaving: false,
    },
    systemTypes: {
        data: [],
        errors: [],
        isFetching: false,
    },
    isNewRecord: true,
    isOpenModal: false,
};

const createTemplateModalSlice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [FETCH_SYSTEM_TYPES]: (state) => {
            state.systemTypes = {
                ...state.systemTypes,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_SYSTEM_TYPES_FAILURE]: (state, action) => {
            state.systemTypes = {
                ...state.systemTypes,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_SYSTEM_TYPES_SUCCESS]: (state, action) => {
            state.systemTypes = {
                ...state.systemTypes,
                data: action.payload,
                isFetching: false,
            };
        },
        [INITIALIZE_FORM]: (state, action) => {
            state.initialValues = { ...state.initialValues, ...action.payload };
        },
        [RESET]: () => INITIAL_STATE,
        [RESET_FORM]: (state) => {
            state.initialValues = INITIAL_STATE.initialValues;
            state.save.errors = [];
        },
        [SAVE]: (state) => {
            state.save = { ...state.save, errors: [], isSaving: true };
        },
        [SAVE_FAILURE]: (state, action) => {
            state.save = {
                ...state.save,
                errors: action.payload,
                isSaving: false,
            };
        },
        [SAVE_SUCCESS]: (state, action) => {
            state.save = {
                ...state.save,
                data: action.payload,
                isSaving: false,
            };
        },
        [SET_IS_NEW_RECORD]: (state, action) => {
            state.isNewRecord = action.payload;
        },
        [SET_IS_OPEN_MODAL]: (state, action) => {
            state.isOpenModal = action.payload;
        },
    },
});

export const createTemplateModalActions = createTemplateModalSlice.actions;

export default createTemplateModalSlice.reducer;
